<template>
  <div
    id="shop"
    style="
      display: flex;
      width: 100%;
      flex-direction: column;
    "
  >
    <div id="component-title">
      <h2>Loja virtual</h2>
    </div>
    <div
      id="cards-container"
      v-if="collections && collections.length > 0"
    >
      <div
        id="items-for-sell"
        style="justify-content: center;"
        v-for="(collection, index) in collections"
        :key="index"
      >
        <v-card
          style="max-width: 450px;"
          class="card-style"
          outlined
          v-for="(item, index) in collection.list"
          :key="index"
          :class="checkViewPort()"
        >
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">
                <v-checkbox
                  v-model="checkbox[item.id]"
                  :label="
                        `${item && item.title 
                          ? item.title.substring(0, 20) 
                          : 'Nome de item desconhecido'} 
                          : ${checkbox[item.id] && item.orderQuantity > 0 
                          ? 'Adicionado ao carrinho' 
                          : 'Não selecionado'}`"
                  @click.stop="setItem(item)"
                ></v-checkbox>

                <!-- v-show="checkbox[item.id]" -->
                <div
                  class="order-quantity"
                  :style="(checkbox[item.id] ? 'opacity: 1;' : 'opacity: 0;') + 'height: 55px;'"
                >

                  <v-btn @click="decrease(item)">
                    -
                  </v-btn>
                  <span class="item-order-quantity__span">{{item.orderQuantity}}</span>
                  <v-btn @click="increase(item)">
                    +
                  </v-btn>
                </div>

              </div>

              <img
                :src="item.imgUrl"
                alt="item image"
                style="max-height: 150px; max-width: 150px;"
              >
              <!-- <expandable-image :src="item.imgUrl" /> -->

              <v-list-item-title class="headline mb-1">

                {{ item && item.title ? item.title : 'Nome de item não encontrado' }}

              </v-list-item-title>

              <v-list-item-subtitle>

                {{ item.description }}

              </v-list-item-subtitle>

            </v-list-item-content>

          </v-list-item>

          <v-card-actions>
            <v-btn
              :disabled="checkbox[item.id] === false || item.orderQuantity === 0"
              style="width: 200px;"
              @click="showCreditCardForm = true"
            >
              <img
                class="shopping-cart-icon"
                src="img/shopping-cart.png"
                alt="shopping-cart"
              >
              Adquirir
            </v-btn>
          </v-card-actions>
        </v-card>

      </div>
    </div>

    <v-dialog
      v-model="showCreditCardForm"
      width="80%"
    >

      <v-stepper v-model="e1">
        <v-stepper-header>

          <v-stepper-step
            :complete="e1 > 1"
            step="1"
            :editable="true"
          >Cartão de crédito</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :complete="e1 > 2"
            step="2"
            :editable="true"
            :style="disableStep2 ? 'pointer-events: none' : 'pointer-events: all'"
          >Informações sobre endereço</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            step="3"
            :editable="true"
          > Finalização </v-stepper-step>

        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <h3>Informações sobre o Cartão de crédito</h3>
            <credit-card
              :debugging="debugging"
              :psSessionInitiated="scriptWasLoaded"
              @creditCardInfoFilled="receiveCreditCardInfo()"
              @creditCardInfoNotFullyFilled="receiveCreditCardInfo('notFilled')"
            />

            <div class="stepper-nav-buttons">
              <v-btn
                color="primary"
                @click="showStep2()"
                :disabled="disableStep2"
              >
                Continuar
              </v-btn>

              <v-btn
                text
                @click="showCreditCardForm = false"
              >Cancelar</v-btn>
            </div>

          </v-stepper-content>

          <v-stepper-content step="2">
            <h3>Informações sobre o Endereço de entrega</h3>
            <client-info-form
              :debugging="debugging"
              :baseUrl="baseUrl"
              @userFeedBackInfo="handleUserFeedBackInfo(1)"
              @clientInfoFilled="getUserInfo"
            />

            <div class="stepper-nav-buttons">
              <v-btn
                color="primary"
                @click="showStep3()"
                :disabled="disableStep3"
              >
                Continuar
              </v-btn>

              <v-btn
                text
                @click="showCreditCardForm = false"
              >Cancelar</v-btn>
            </div>

          </v-stepper-content>

          <v-stepper-content step="3">
            <h3>Efetuar pagamento</h3>

            <div id="paypal-container">
            </div>

            <form
              action="https://www.paypal.com/cgi-bin/webscr"
              method="post"
              target="_blank"
            >
              <input
                type="hidden"
                name="cmd"
                value="_s-xclick"
              >
              <input
                type="hidden"
                name="hosted_button_id"
                value="4EBF2TKHZ8JFE"
              >
              <input
                type="image"
                src="https://www.paypalobjects.com/pt_BR/BR/i/btn/btn_buynowCC_LG.gif"
                border="0"
                name="submit"
                alt="PayPal - A maneira fácil e segura de enviar pagamentos online!"
              >
              <img
                alt=""
                border="0"
                src="https://www.paypalobjects.com/pt_BR/i/scr/pixel.gif"
                width="1"
                height="1"
              >
            </form>

            <v-btn
              color="primary"
              @click="e1 = 1"
              :disabled="disableSubmitButton"
            >
              Finalizar
            </v-btn>

            <v-btn
              text
              @click="showCreditCardForm = false"
            >Cancelar</v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>

    </v-dialog>

    <v-snackbar
      v-model="showUserInfo"
      :timeout="timeout"
      color="red"
    >
      <span style="color: white">
        {{ userInfo }}
      </span>
      <v-btn
        color="black"
        text
        @click="closeSnack()"
      >
        Fechar
      </v-btn>
    </v-snackbar>

    <v-progress-circular
      style="width: 100%"
      indeterminate
      v-if="showProgress"
      color="primary"
      class="bottom"
    />
  </div>
</template>

<script>
import mixins from "../assets/mixins.js"
import { eventBus } from "../main.js"
import CreditCard from "../components/CreditCard.vue"
import ClientInformationForm from "../components/ClientInformationForm.vue"

export default {
  name: "shop",
  mixins: [mixins],
  components: {
    "credit-card": CreditCard,
    "client-info-form": ClientInformationForm,
  },
  beforeDestroy() {
    if (this.scriptWasLoaded) {
      this.$unloadScript(
        "https://stc.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js"
      )
        .then(() => {
          console.log("pagseguro script unloaded")
          this.scriptWasLoaded = false
        })
        .catch((err) => {
          console.log("pagseguro script unload problem", err)
        })
    }
  },
  mounted() {
    eventBus.$on("updateLanguage", this.setLang)
    this.debugging = true
    if (this.debugging) {
      // this.baseUrl = "http://localhost:3000"
      this.baseUrl = "https://login-anantadeva.herokuapp.com"
    } else {
      this.baseUrl = "https://login-anantadeva.herokuapp.com"
    }

    this.$loadScript("https://www.paypal.com/sdk/js?client-id=sb").then(
      (res) => {
        console.log(
          "this.$loadScript(https://www.paypal.com/sdk/js?client-id=sb)",
          res
        )
        // 
        // setTimeout(() => {

        // }, 5000);
      }
    )

    // this.initPagSeguro()
    // this.$loadScript(
    //   "https://stc.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js"
    // ).then(result => {
    //
    //   console.log("pagseguro script loaded", result)
    // }).catch(err => {
    //   console.error('pagseguro script load problem', err)
    //   this.showSnackInfo('Erro ao carregar scripts. Tentar atualizar a página apertando F5')
    // })

    this.fetchStore()
  },
  watch: {
    // userInfo(newValue) {
    //   if (newValue) {
    //   }
    // }
  },
  computed: {
    // disableStep2() {},
    language() {
      if (this.lang) {
        return this.lang
      } else {
        this.checkLanguage()
      }
      return this.lang
    },
  },
  data() {
    return {
      debugging: null,
      buyerData: null,
      timeout: 60000,
      clientCardToken: null,
      psHash: null,
      psSessionId: null,
      disableStep2: true,
      disableStep3: true,
      disableSubmitButton: true,
      checkbox: [],
      scriptWasLoaded: false,
      e1: 1,
      showCreditCardForm: false,
      collections: [],
      baseUrl: null,
      storeUrl: "/store",
      pagSegSessionIdUrl: "/pagseguro-session-id",
      showProgress: false,
      viewPortWidth: window.innerWidth,
      showUserInfo: false,
      userInfo: null,
      creditCardInfo: {},
      order: {},
    }
  },
  methods: {
    closeSnack() {
      snackbar = false
      userInfo = null
    },
    showStep3() {
      this.e1 = 3
      setTimeout(() => {
        
        if (document.getElementById("paypal-container")) {
          paypal.Buttons().render(
            {
              env: "production",

              locale: "pt_PT",

              style: {
                size: "small",
                color: "gold",
                shape: "pill",
                label: "checkout",
              },
            },
            "#paypal-container"
          )
          document
            .querySelector(
              "#inspire > div.v-dialog__content.v-dialog__content--active > div"
            )
            .scroll(0, 0)
        }
      }, 200)
    },
    showStep2() {
      this.e1 = 2
      setTimeout(() => {
        document
          .querySelector(
            "#inspire > div.v-dialog__content.v-dialog__content--active > div"
          )
          .scroll(0, 0)
      }, 100)
    },
    decrease(item) {
      this.order[item.id]
      item.orderQuantity > 0 ? item.orderQuantity-- : null
      let v = this.setQuantityAndValue(item)
      this.order.totalValue -= v
    },
    increase(item) {
      item.orderQuantity < item.stockQtt
        ? item.orderQuantity++
        : this.noMoreAllowedAlert(item.stockQtt)
      let v = this.setQuantityAndValue(item)
      this.order.totalValue += v
    },
    setQuantityAndValue(item) {
      let v = this.getValue(item.id) * item.orderQuantity
      this.order[item.id] = {
        quantity: item.orderQuantity,
        value: v,
      }
      return v
    },
    getValue(itemId, quantity) {
      switch (itemId) {
        case "bg40v":
          return 5
        case "bgFull":
          return 15
        case "atulanandaRMTM":
          return 15
        case "revCol1_2":
          return 5

        default:
          break
      }
    },
    setItem(item) {
      this.checkbox[item.id] = !this.checkbox[item.id]
      item.orderQuantity === 0 ? this.increase(item) : null
    },
    showSnackInfo(msg) {
      
      this.showUserInfo = true
      this.userInfo = msg
    },
    creditCardInfoNotFilled() {
      this.disableStep2 = true
      this.creditCardInfo = null
    },
    receiveCreditCardInfo(values) {
      if (values === "notFilled") {
        this.disableStep2 = true
        this.creditCardInfo = null
      } else {
        this.creditCardInfo = { ...values }
        this.disableStep2 = false
        this.createUserHash()
      }
    },

    createUserHash() {
      PagSeguroDirectPayment.onSenderHashReady((response) => {
        if (response.status == "error") {
          console.log(response.message)
          return false
        }
        this.psHash = response.senderHash //Hash estará disponível nesta variável.
      })
    },

    getUserInfo(args) {
      if (args === "not-filled") {
        this.disableSubmitButton = true
        this.showUserInfo = false
        this.disableStep3 = true
        this.userInfo = null
      } else {
        this.disableStep3 = false
        this.disableSubmitButton = false
        // this.showUserInfo = true
        this.buyerData = args
      }
    },

    handleUserFeedBackInfo(errorMessage) {
      this.showUserInfo = true
      if (errorMessage === 1)
        this.userInfo =
          "É necessário informar o logradouro e o número do local de entrega!"
      else this.userInfo = errorMessage
    },

    resetQuantity(item) {
      setTimeout(() => {
        item.orderQuantity = 1
      }, 200)
    },

    noMoreAllowedAlert(qtt) {
      this.showUserInfo = true
      this.userInfo = `A quantidade disponível em estoque é ${qtt}. Não é possível solicitar mais que essa quantidade`
    },

    checkViewPort() {
      if (this.viewPortWidth < 600) return "col-xs-5"
      else if (this.viewPortWidth < 1200) return "col-sm-5"
      else return "col-sm-5"
    },

    populateCheckbox() {
      if (
        this.collections &&
        this.collections[0] &&
        this.collections[0].list &&
        this.collections[0].list.length > 0
      ) {
        let arr = []
        this.collections[0].list.forEach((el) => {
          // arr[el.id] = false
          this.$set(this.checkbox, el.id, false)
          el.orderQuantity = 0
        })
        // this.checkbox = JSON.parse(JSON.stringify(arr))
      }
    },

    checkLastUpdate() {
      if (this.debugging) return false
      return new Promise((resolve) => {
        return fetch(this.baseUrl + "/check-last-update", {
          method: "GET",
        })
          .then((response) => response.json())
          .then((result) => {
            let localUpdatedAt = localStorage.getItem("updatedAt"),
              localItems = localStorage.getItem("collections")

            if (
              (!localUpdatedAt && localItems) ||
              !localItems ||
              (localUpdatedAt &&
                result.updatedAt &&
                Number.parseInt(localUpdatedAt) !== result.updatedAt)
            ) {
              localStorage.removeItem("collections")
              localStorage.setItem("updatedAt", result.updatedAt)

              return resolve(true)
            }
            // else if (
            //   localUpdatedAt &&
            //   result.updatedAt &&
            //   localUpdatedAt !== result.updatedAt
            // ) {

            //   localStorage.setItem('updatedAt', result.updatedAt)
            //   localStorage.removeItem('collections')
            //   return resolve(true)

            // }

            return resolve(false)
          })
      })
    },

    async fetchStore() {
      this.collections = JSON.parse(
        localStorage.getItem("collections", this.collections)
      )

      const fetchAgainFromSource = await this.checkLastUpdate()

      if (!this.collections || fetchAgainFromSource) {
        this.showProgress = true
        fetch(this.baseUrl + this.storeUrl, {
          method: "GET",
        })
          .then((response) => response.json())
          .then((result) => {
            if (result.store && result.store.length > 0) {
              this.collections = result.store

              this.populateCheckbox()

              localStorage.setItem(
                "collections",
                JSON.stringify(this.collections)
              )

              setTimeout(() => {
                this.showProgress = false
              }, 1000)
            } else if (result.store && result.store.length === 0) {
              this.showProgress = false
            }
          })
          .catch((err) => {
            console.error(err)
          })
      } else {
        this.populateCheckbox()
      }
    },

    registerEventListenerCardBrandGetter() {
      // PagSeguroDirectPayment.getBrand({
      //   cardBin: 411111,
      //   success: function(response) {
      //     //bandeira encontrada
      //   },
      //   error: function(response) {
      //     //tratamento do erro
      //   },
      //   complete: function(response) {
      //     //tratamento comum para todas chamadas
      //   }
      // })
    },

    initPagSeguro() {
      fetch(this.baseUrl + this.pagSegSessionIdUrl, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((json) => {
          if (json.pagseguroId) {
            this.$loadScript(
              // "../assets/pagseguro-directpayment.js"
              "https://stc.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js"
            )
              .then(() => {
                // this.showCreditCardForm = true

                PagSeguroDirectPayment.setSessionId(json.pagseguroId)
                this.scriptWasLoaded = true

                PagSeguroDirectPayment.getPaymentMethods({
                  amount: 500.0,
                  success: function (response) {
                    console.log("getPaymentMethods - success", response)
                    // Retorna os meios de pagamento disponíveis.
                  },
                  error: function (response) {
                    console.log("getPaymentMethods - error", response)
                    // Callback para chamadas que falharam.
                  },
                  complete: function (response) {
                    console.log("getPaymentMethods - complete", response)
                    // Callback para todas chamadas.
                  },
                })

                // this.registerEventListenerCardBrandGetter()
              })
              .catch(() => {
                // Failed to fetch script
                this.showSnackInfo(
                  "Erro ao carregar scripts. Tentar atualizar a página apertando F5"
                )
              })
          }
        })
    },
  },
}
</script>

<style>
#items-for-sell {
  display: flex;
  /* width: 100%; */
  flex-direction: row;
  flex-wrap: wrap;
}

/* #cards-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 80%;
  margin: 0 auto;
} */

.card-style.v-card.v-card--outlined.v-sheet.theme--light {
  margin: 1%;
}

.expandable-image {
  /* max-width: 40vh; */
}

.shopping-cart-icon {
  width: 15%;
  margin: 0 4%;
}

.order-quantity {
  display: flex;
  flex-direction: row;
}

.v-input--selection-controls__input {
  margin-left: 3%;
}

.item-order-quantity__span {
  font-size: 34px;
  padding: 2%;
  width: fit-content;
  margin: 1% 3%;
}

.expand-button {
  z-index: 10 !important;
}

#component-title {
  width: 90%;
  display: flex;
}

#component-title h2 {
  margin: 0 auto;
}

.v-stepper__wrapper {
  height: 280vh;
  display: flex;
  flex-direction: column;
}

.v-stepper__items {
  height: 270vh;
}

.v-stepper__content {
  height: 250vh;
}

.v-list-item__subtitle {
  display: contents;
}
</style>